var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4879 16.6923H5.5135C5.17348 16.6923 4.84738 16.5573 4.60695 16.3168C4.36652 16.0764 4.23145 15.7503 4.23145 15.4103V3.87183H15.7699V15.4103C15.7699 15.7503 15.6348 16.0764 15.3944 16.3168C15.154 16.5573 14.8279 16.6923 14.4879 16.6923Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.07715 12.8462V7.71802",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9238 12.8462V7.71802",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.66699 3.87183H18.3337",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.9231 1.30774H8.07697C7.73695 1.30774 7.41086 1.44281 7.17043 1.68324C6.92999 1.92367 6.79492 2.24977 6.79492 2.58979V3.87184H13.2052V2.58979C13.2052 2.24977 13.0701 1.92367 12.8297 1.68324C12.5892 1.44281 12.2631 1.30774 11.9231 1.30774Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinIcon);
export default __webpack_public_path__ + "static/media/DeleteBinIcon.3d9c7f32bc60202b935db4288e74bea5.svg";
export { ForwardRef as ReactComponent };